module.exports = {"head":{"title":"The list"},"title":"List","iDalgoDefault":{"myAccount":"My account","logout":"Log out","dashboard":"Dashboard","archives":"Archives","analytics":"Analytics"},"CTA":{"new":"New list","connection":"connection","add":"+ Add","share":"Share","duplicate":"Duplicate","delete":"Delete","edit":"Edit","copy":"Copy","cancel":"Cancel"},"BAROMETER":"Barometer","PLAYERLIST":"The list","SURVEY":"Surveys"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = yZm8
// module chunks = 1